"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

function secondsToDhms(remainingSeconds) {
  var oneMinute = 60; // seconds

  var oneHour = oneMinute * 60;
  var oneDay = oneHour * 24;
  var days = Math.floor(remainingSeconds / oneDay);
  var hours = Math.floor(remainingSeconds % oneDay / oneHour);
  var minutes = Math.floor(remainingSeconds % oneHour / oneMinute);
  var seconds = Math.floor(remainingSeconds % oneMinute);
  return {
    days: days,
    hours: hours,
    minutes: minutes,
    seconds: seconds
  };
}

var _default = secondsToDhms;
exports["default"] = _default;
//# sourceMappingURL=secondsToDhms.js.map